/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  var App = {
    initFoundation: function () {
      $(document).foundation()
    },
    handleMoreItems: function () {
      $('[rel=js-expand-list-more]').on('click', function () {
        var target = $(this).data('expand-class')
        $('.' + target).toggleClass('expanded')
      })
    },
    initGooglePlaces: function () {
      console.log('this init google');
      var inputs = document.querySelectorAll('[rel="google-map-places"]')
      if (inputs.length > 0) {
        var options = {
          types: ['geocode'],
          componentRestrictions: { country: 'us' },
        }
        Array.prototype.forEach.call(inputs, function (input) {
          autocomplete = new google.maps.places.Autocomplete(input, options)
        })
        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        autocomplete.addListener('place_changed', function () {
          var componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            postal_code: 'short_name'
          };
          // Get the place details from the autocomplete object.
          var place = autocomplete.getPlace()

          for (var component in componentForm) {
            document.getElementById(component).value = '';
          }

          // Get each component of the address from the place details
          // and fill the corresponding field on the form.
          for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
              var val = place.address_components[i][componentForm[addressType]];
              document.getElementById(addressType).value = val;
            }
          }
          // document.getElementById('full_route').value =
          //   place.address_components[0]['long_name'] + ' ' +
          //   place.address_components[1]['long_name'];
        });
      }
    },
    zipLock: function () {
      $('.input--zip').keypress(function (key) {
        if (key.charCode < 48 || key.charCode > 57) return false
      })
    },
    handleSearchClosestFranchiseSubmit: function () {

      $('[rel=js-search-closest-franchise]').on('submit', function (e) {
        e.preventDefault()
        var _self = this
        $.post(
          $(_self).attr('action'),
          $(_self).serialize(),
          function (res) {
            if (!res.error) {
              // Set JSON, Read by .getJSON('name')
              Cookies.set('petbutler', res.data, { expires: 365, path: '/' })
              var closest_franchise = res.data.user.closest_franchise
              // Redirect to franchise page
              if (typeof res.data.user.referer !== 'undefined') {
                window.location.href = res.data.user.referer;
                return;
              }
              if (typeof closest_franchise.url !== 'undefined') {
                window.location.href = closest_franchise.url;
                return;
              }
              window.location.href = '/thank-you/';
            } else {
              var msg = '********************************\n\n'
              msg += 'Message: ' + res.message + '\n\n'
              msg += '********************************'
              alert(msg)
            }
          }, 'json')
      })
    },
    prepopulateInputData: function () {
      var petbutler = Cookies.getJSON('petbutler')
      if (typeof petbutler !== 'undefined') {

        var user = petbutler.user;
        if (typeof petbutler.user.ppcguid !== 'undefined') {
          if ($('#pricingFormFullData').length > 0) {
            $('#pricingFormFullData').hide();
          }
          if ($('#pricingFormPPC').length > 0) {
            $('#pricingFormPPC').find('[name=guid]').val(petbutler.user.ppcguid);
            $('#pricingFormPPC').show();
          }

        }
        if (typeof user.address.zip !== 'undefined') {
          $('[data-address-zip]').val(user.address.zip)
        }
        if (typeof user.address.street !== 'undefined') {
          $('[data-address-city]').val(user.address.city)
          $('[data-address-state]').val(user.address.state)
          var address = user.address.streetNumber + ' ' + user.address.street
          $('[data-address-full]').val(address)
        }
      }
    },
    handleSearchClosestEmploymentServiceSubmit: function () {

      $('[rel=search-employment-services]').on('submit', function (e) {
        e.preventDefault()
        var _self = this
        $.post(
          $(_self).attr('action'),
          $(_self).serialize(),
          function (res) {
            var url = 'https://pet-butler-careers.careerplug.com/jobs';
            if (res['data'] && res['data']['employment_service_redirect']) {
              url = res['data']['employment_service_redirect'];
            } else if (res['error'] && res['error'] === true) {
              console.error(res['message']);
            } else {
              console.error(JSON.stringify(res));
            }
            window.location = url;
          }, 'json')
          .fail(function (err) {
            alert("error: " + err['message']);
          })
      })
    },
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        App.initFoundation()
        App.handleMoreItems()
        App.zipLock()
        App.initGooglePlaces()
        App.handleSearchClosestFranchiseSubmit()
        App.handleSearchClosestEmploymentServiceSubmit()
        App.prepopulateInputData()
        if ((typeof autoSubmitMainSearchForm != 'undefined') && (autoSubmitMainSearchForm)) {
          $('#mainSearchFranchiseForm').trigger('submit');
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // App.initGooglePlaces();
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'page_template_template_location': {
      init: function () {
        LocationPage.handleFranchiseFilter()
      },
      finalize: function () {
        // JavaScript to be fired on the location page, after the init JS
      },
    },
    'page_template_template_local_butler_no_zip': {
      init: function () {
        MyLocalButlerPage.checkRedirect()
      },
      finalize: function () {
        // JavaScript to be fired on the location page, after the init JS
      },
    },
    'page_template_template_terms_of_service': {
      init: function () {
        var petbutler = Cookies.getJSON('petbutler')
        if (typeof petbutler.user.closest_franchise.id !== 'undefined') {
          $.post(
            '/wp-admin/admin-ajax.php',
            {
              'action': 'find_franchise_by_id',
              'id': petbutler.user.closest_franchise.id,
            }, function (res) {
              if (typeof res.error !== 'undefined' && !res.error) {
                $('#terms-of-use').
                  html(PetButler.templates.term_of_service(res.data))
              } else {
                console.log(res.message);
              }
            }, 'json')
        }
      },
      finalize: function () {
        // JavaScript to be fired on the location page, after the init JS
      },
    },
    'page_template_template_terms_of_use': {
      init: function () {
        var petbutler = Cookies.getJSON('petbutler')
        if (typeof petbutler.user.closest_franchise.id !== 'undefined') {
          $.post(
            '/wp-admin/admin-ajax.php',
            {
              'action': 'find_franchise_by_id',
              'id': petbutler.user.closest_franchise.id,
            }, function (res) {
              if (typeof res.error !== 'undefined' && !res.error) {
                $('#terms-of-use').
                  html(PetButler.templates.term_of_use(res.data))
              } else {
                console.log(res.message);
              }
            }, 'json')
        }
      },
      finalize: function () {
        // JavaScript to be fired on the location page, after the init JS
      },
    },
    'page_template_template_privacy': {
      init: function () {
        var petbutler = Cookies.getJSON('petbutler')
        if (typeof petbutler.user.closest_franchise.id !== 'undefined') {
          $.post(
            '/wp-admin/admin-ajax.php',
            {
              'action': 'find_franchise_by_id',
              'id': petbutler.user.closest_franchise.id,
            }, function (res) {
              if (typeof res.error !== 'undefined' && !res.error) {
                $('#privacy').
                  html(PetButler.templates.privacy_policy(res.data))
              } else {
                console.log(res.message);
              }
            }, 'json')
        }
      },
      finalize: function () {
        // JavaScript to be fired on the location page, after the init JS
      },
    }
  }

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire
      var namespace = Sage
      funcname = (funcname === undefined) ? 'init' : funcname
      fire = func !== ''
      fire = fire && namespace[func]
      fire = fire && typeof namespace[func][funcname] === 'function'

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
